












import _ from 'lodash'
import { Validator } from 'vee-validate'
import Vue from 'vue'
import { Component, Inject, Prop } from 'vue-property-decorator'

import DropdownSelect from '../../atoms/DropdownSelect.vue'
import { SelectItem } from '../../atoms/model/SelectItem'

@Component({
  components: {
    DropdownSelect,
  },
})
export default class MonthDropdown extends Vue {
  @Prop({ required: true })
  readonly value: string

  @Prop({ default: 'month' })
  readonly name: string

  @Prop({
    // default: 全ての要素を有効とする
    default: () => (() => false),
  })
  readonly disableFilter: (month: string) => boolean

  @Inject()
  readonly $validator: Validator

  get monthList(): SelectItem[] {
    return [
      {
        value: '',
        text: 'MM',
        selected: _.isEmpty(this.value),
        disabled: true,
      },
      // 12ヶ月をそれぞれ2桁で表現
      // tslint:disable-next-line:no-magic-numbers
      ..._.range(1, 13).map(v => (`0${v}`).slice(-2)).map((month: string) => ({
        value: `${month}`,
        text: `${month}`,
        selected: month === this.value,
        disabled: this.disableFilter(month),
      })),
    ]
  }

  onInput(value) {
    this.$emit('input', value)
  }
}
